var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit, Model } from "vue-property-decorator";
import { operates, links } from "./strategy-helper.config";
import { StrategyConfigService } from "~/services/dataimp-service/strategy-config.service";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
import { DictService } from "~/utils/dict.service";
import { CityService } from "~/utils/city.service";
import SvgIcon from "~/components/common/svg-icon.vue";
var ExpressionBase = /** @class */ (function (_super) {
    __extends(ExpressionBase, _super);
    function ExpressionBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bracket = links.bracket;
        _this.fieldDataSet = [];
        _this.preView = false;
        return _this;
    }
    ExpressionBase.prototype.emitExpressionDataSet = function (data) { };
    ExpressionBase.prototype.deleteClick = function (index) {
        this.expressionDataSet.splice(index, 1);
        if (index === 0) {
            this.expressionDataSet[index].relation = " ";
        }
        this.sendData();
    };
    ExpressionBase.prototype.sendData = function () {
        this.emitExpressionDataSet(this.expressionDataSet.map(function (v) { return (__assign({}, v)); }));
    };
    /**
     * 新增行的时候判断 连接符是什么
     */
    ExpressionBase.prototype.getRelationOptions = function (index) {
        return index === 0 ? links.relation.first : links.relation.normal;
    };
    Object.defineProperty(ExpressionBase.prototype, "preViewExpressionStr", {
        get: function () {
            var str = "";
            str = this.expressionDataSet.map(function (v) {
                return [v.relation, v.leftBracket, v.variable, v.symbol, v.value, v.rightBracket].join(' ');
            }).join(' ');
            return str;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 字段值变化，其他的数据需要清空重新设置
     */
    ExpressionBase.prototype.onVariableChange = function (row, index) {
        row.symbol = "";
        row.value = '';
        if (row.cascaderValue)
            row.cascaderValue = [];
        row.operateType = this.valueOperateType(row.variable);
        this.sendData();
    };
    ExpressionBase.prototype.onCascaderChange = function (row, values) {
        row.value = values.length ? values[values.length - 1] : '';
        this.sendData();
    };
    /**
     * 根据字段获取需要的操作符
     */
    ExpressionBase.prototype.getSymbolOptions = function (field) {
        var fieldConfig = this.fieldDataSet.find(function (x) { return x.field === field; });
        return fieldConfig ? operates.filter(function (x) { return x.enable.includes(fieldConfig.symbol); }) : [];
    };
    /**
     * 获取操作类型
     */
    ExpressionBase.prototype.valueOperateType = function (field) {
        var fieldConfig = this.fieldDataSet.find(function (x) { return x.field === field; });
        if (!fieldConfig)
            return '';
        var type = "INPUT";
        switch (fieldConfig.source) {
            case "DICT":
            case "DATA":
                type = "SELECT";
                break;
            case "OTHER":
                type = this.getOtherType(fieldConfig.key);
                break;
            default:
                break;
        }
        return type;
    };
    /**
     * 其他数据的数据类型
     */
    ExpressionBase.prototype.getOtherType = function (key) {
        var type = "INPUT";
        switch (key) {
            case 'CITY':
                type = "CASCADER";
                break;
            case 'DATE':
                type = "DATEPTCKER";
                break;
            default:
                break;
        }
        return type;
    };
    /**
     * 获取值选择数据源
     */
    ExpressionBase.prototype.getValueOptions = function (field) {
        var fieldConfig = this.fieldDataSet.find(function (x) { return x.field === field; });
        var source = [];
        if (!fieldConfig)
            return [];
        if (fieldConfig.source === "DICT") {
            // 如果是数据字典，则获取数据字典数据作为期望值的数据源
            return DictService.getDictData(fieldConfig.key);
        }
        else if (fieldConfig.source === "DATA") {
            return fieldConfig.dataList;
        }
        else {
            return this.getLocalData(fieldConfig.key);
        }
    };
    /**
     * 获取值选择数据源-- 本地数据源
     */
    ExpressionBase.prototype.getLocalData = function (type) {
        var data = [];
        switch (type) {
            case "CITY":
                data = CityService.getCityData({ level: 2 });
                break;
            default:
                break;
        }
        return data;
    };
    ExpressionBase.prototype.mounted = function () {
        var _this = this;
        // 加载支持的字段和关联数据
        if (this.flag) {
            this.labelingStrategyService.getLabelFields().subscribe(function (data) { return _this.fieldDataSet = data; });
        }
        else {
            this.strategyConfigService.getLabelNameFields().subscribe(function (data) { return _this.fieldDataSet = data; });
        }
    };
    __decorate([
        Dependencies(StrategyConfigService)
    ], ExpressionBase.prototype, "strategyConfigService", void 0);
    __decorate([
        Dependencies(LabelingStrategyService)
    ], ExpressionBase.prototype, "labelingStrategyService", void 0);
    __decorate([
        Model("expressin-change")
    ], ExpressionBase.prototype, "expressionDataSet", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], ExpressionBase.prototype, "openData", void 0);
    __decorate([
        Prop({ type: String })
    ], ExpressionBase.prototype, "modifyData", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ExpressionBase.prototype, "disabledData", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], ExpressionBase.prototype, "flag", void 0);
    __decorate([
        Prop({ type: String })
    ], ExpressionBase.prototype, "val", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ExpressionBase.prototype, "show", void 0);
    __decorate([
        Emit("expressin-change")
    ], ExpressionBase.prototype, "emitExpressionDataSet", null);
    ExpressionBase = __decorate([
        Component({
            components: {
                SvgIcon: SvgIcon
            }
        })
    ], ExpressionBase);
    return ExpressionBase;
}(Vue));
export default ExpressionBase;
